require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/es6.array.species.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/es6.array.species.js
// module chunks = 0